import React, { useState, useEffect, useContext } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import AvatarDisplay from '../components/AvatarDisplay';

const ENSSearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { getAuthHeaders } = useContext(AuthContext);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!query || query.length < 2) {
      setResults([]);
      return;
    }

    const fetchResults = async () => {
      setLoading(true);
      setError('');
      try {
        const headers = getAuthHeaders();
        const res = await fetch(`/api/ens/search?q=${encodeURIComponent(query)}`, { headers });
        const data = await res.json();
        if (data.success) {
          setResults(data.results);
        } else {
          setError(data.error || 'Search failed');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [query, getAuthHeaders]);

  return (
    <div className="ens-search-page" style={{ padding: '2rem' }}>
      <h2 style={{ color: 'var(--gold)' }}>ENS Domain Search</h2>
      <p style={{ color: 'var(--text-secondary)' }}>
        Results for: <strong>{query}</strong>
      </p>

      {loading && <div>Loading...</div>}
      {error && <div style={{ color: '#ff4444' }}>{error}</div>}
      {!loading && !error && results.length === 0 && query.length >= 2 && (
        <div style={{ color: 'var(--text-secondary)' }}>No matching domains found.</div>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '1rem',
        marginTop: '2rem'
      }}>
        {results.map(user => (
          <Link
            key={user.eth_address}
            to={`/profile/${user.eth_address}`}
            style={{ textDecoration: 'none' }}
          >
            <div style={{
              background: 'var(--card-bg)',
              border: '1px solid var(--border)',
              borderRadius: '8px',
              padding: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              transition: 'all 0.2s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--gold)';
              e.currentTarget.style.boxShadow = '0 4px 12px var(--gold-shadow)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--border)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <AvatarDisplay
                ensName={user.ens_name}
                address={user.eth_address}
                avatarUrl={user.avatar_url}
                size={50}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: 'var(--gold)', fontWeight: 'bold', marginBottom: '0.25rem' }}>
                  {user.ens_name}
                </div>
                {user.bio && (
                  <div style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '0.25rem' }}>
                    {user.bio.length > 60 ? user.bio.substring(0, 60) + '…' : user.bio}
                  </div>
                )}
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                  {user.follower_count} followers
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ENSSearchPage;
